/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { UFOExperienceState, UFOExperience, ConcurrentExperience, ExperienceTypes, ExperiencePerformanceTypes, GlobalPageLoadExperience, AbstractExperienceConfig, perfNowOrTimestamp, EndStateConfig } from '@atlassian/ufo-experimental/src/platform-client/core/index'` instead.
 */
export {
	UFOExperienceState,
	UFOExperience,
	ConcurrentExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	GlobalPageLoadExperience,
	type AbstractExperienceConfig,
	perfNowOrTimestamp,
	type EndStateConfig,
} from './core';

/**
 * @deprecated Use `import { useUFOExperience } from '@atlassian/ufo-experimental/use-ufo-experience'` instead.
 */
export { useUFOExperience } from './hooks/useUFOExperience';
/**
 * @deprecated Use `import { useUFOStreamingExperience } from '@atlassian/ufo-experimental/use-ufo-streaming-experience'` instead.
 */
export { useUFOStreamingExperience } from './hooks/useUFOStreamingExperience';
